import service from "@/store/services/users-service";

const state = {
  list: {},
  user: {},
  meta: {},
  url: null,
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, user) => {
    state.user = user;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service
      .list(params)
      .then(({ list, meta }) => {
        commit("SET_LIST", list);
        commit("SET_META", meta);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  get({ commit, dispatch }, params) {
    return service
      .get(params)
      .then((user) => {
        if (user.hasOwnProperty("data") && user.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
            "Server responded with error = True <br> errorCode: " +
            user.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", user);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  add({ commit, dispatch }, params) {
    return service
      .add(params)
      .then((user) => {
        if (user.hasOwnProperty("data") && user.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
            "Server responded with error = True <br> errorCode: " +
            user.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", user);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  update({ commit, dispatch }, params) {
    return service
      .update(params)
      .then((user) => {
        if (user.hasOwnProperty("data") && user.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
            "Server responded with error = True <br> errorCode: " +
            user.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", user);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },

  upload({ commit, dispatch }, { user, image }) {
    return service
      .upload(user, image)
      .then((url) => {
        if (url.hasOwnProperty("data") && url.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
            "Server responded with error = True <br> errorCode: " +
            url.data.errorCode,
            { root: true }
          );
        }
        commit("SET_URL", url);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  user: (state) => state.user,
  url: (state) => state.url,
};

const users = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default users;
